// extracted by mini-css-extract-plugin
export default {"container":"about_container__SXb4g","section":"about_section__TxQAP"};